import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPackageSearch: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="package-search,delivery"><path d="M11.25 20.25H3.75V3.75H8.75M8.75 3.75H15.25M8.75 3.75V9.25H15.25V3.75M15.25 3.75H20.25V11.25M19.3713 19.364C18.1997 20.5355 16.3003 20.5355 15.1287 19.364C13.9571 18.1924 13.9571 16.2929 15.1287 15.1213C16.3003 13.9497 18.1997 13.9497 19.3713 15.1213C20.5429 16.2929 20.5429 18.1924 19.3713 19.364ZM19.3713 19.364L21.25 21.2426" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPackageSearch;
